import { createAction } from 'redux-actions'
import axios from 'axios'
import ReactGA from 'react-ga'

import config from '../../config'
import { getAppDomain, getAppPDV } from '../app/selectors'

export const garageSetData = createAction('GARAGE:SETDATA')
export const garageSetServices = createAction('GARAGE:SETSERVICES')

export const garageInitError = createAction('GARAGE:INITERROR')
export const garageInitSuccess = createAction('GARAGE:INITSUCCESS')

const computeURL = (domain, pdvID) => {
  const baseUrl = `${config.apiUrl}prestazioni-web?domain=${domain}`
  if (pdvID === null) return baseUrl
  return `${baseUrl}&pdv=${pdvID}`
}

export const initServices = () => async (dispatch, getState) => {
  try {
    const domain = getAppDomain(getState())
    const pdvID = getAppPDV(getState())
    ReactGA.set({ appInstallerId: domain });

    const result = await axios.get(computeURL(domain, pdvID))

    dispatch(garageSetServices(result.data.content.filter(service => !!service)))
    dispatch(garageInitSuccess())
  } catch (e) {
    dispatch(garageInitError(e))
  }
}
